export default __webpack_public_path__ + "static/media/bg5.db21cb6c.mp4";